export const ru = {
  app: {
    title: "Цифровые двойники",
    subtitle: "Интервью",
    logout: "Выйти",
  },
  auth: {
    login: "Войти",
    register: "Зарегистрироваться",
    email: "Электронная почта",
    password: "Пароль",
    haveAccount: "Уже есть аккаунт?",
    needAccount: "Нет аккаунта?",
    submitting: "Отправка…",
    invalidCredentials: "Неверная почта или пароль",
    unknownError: "Не удалось связаться с сервером",
  },
  common: {
    loading: "Загрузка…",
    error: "Ошибка",
    retry: "Повторить",
    back: "Назад",
    next: "Далее",
    offline: "Нет соединения",
  },
  interview: {
    start: "Начать интервью",
    resume: "Продолжить интервью",
    progress: "Прогресс",
    answered: "Отвечено",
    yourAnswer: "Ваш ответ",
    savedAnswer: "Ранее сохранённый ответ",
    sendAnswer: "Отправить ответ",
    voice: "Ответить голосом",
    prev: "Предыдущий вопрос",
    nextQuestion: "Следующий вопрос",
    jump: "Перейти к номеру",
    rewrite: "Перезаписать ответ",
  },
};

export type Translations = typeof ru;
